import React, {useEffect, useRef, useState, useMemo, useCallback } from "react";
import {useSelector} from "react-redux";
import VideoPlayer from "../../../video/video_room/player/video_player";
import {attributesToProps, domToReact} from 'html-react-parser'

const RenderedTimedVideoRoomContent = ({videoRoom, currentTime, node, options}) => {
  const props = attributesToProps(node.attribs);
  const overlayTimings = useSelector(state => state.htmlContents || []).find(item => item.identifier == `video_room.overlay_timings.${videoRoom.id}`)?.json

  const start = node.attribs["data-start"]
  const end = node.attribs["data-end"]
  const [showOverlay, setShowOverlay] = useState(!start && !end)

  useEffect(() => {
    if (start || end) {
      setShowOverlay((start && end && currentTime > start && currentTime < end) || overlayTimings?.timings.some(timing => timing?.beginning && timing.ending && currentTime > timing?.beginning && currentTime < timing?.ending))
    }
  }, [start, end, currentTime])

  const content = useMemo(() => {
    if (showOverlay) {
      return <div {...props}>
        {domToReact(node.children, options)}
      </div>
    }

    return null
  }, [showOverlay])

  return content
}

const RenderedVideoRoom = ({node, options}) => {
  const videoOverlayContainerRef = useRef(null)
  const videoRooms = useSelector(state => state.videoRooms)
  const [currentTime, setCurrentTime] = useState()
  const videoRoom = videoRooms?.find(vr => (node.attribs["data-videoroom-identifier"] && vr.identifier == node.attribs["data-videoroom-identifier"]) || (node.attribs["data-video-room-identifier"] && vr.identifier == node.attribs["data-video-room-identifier"]) || (node.attribs["data-video_room_identifier"] && vr.identifier == node.attribs["data-video_room_identifier"]))

  const overlayNodes = node.children.filter(child => child.attribs?.role == "video-room-overlay")
  const timedContent = node.children.filter(child => child.attribs?.role == "video-room-timed-content")

  if (!videoRoom) {
    return <div className={"alert alert-danger"}>
      NO VIDEO ROOM FOUND FOR VIDEO-ROOM DIV. No video rooms available in state.
    </div>
  }


  const handleOnTimeUpdated = useCallback((event, currentTime) => {
    if(overlayNodes.length > 0) {
      setCurrentTime(currentTime)
    }
  }, [setCurrentTime, overlayNodes.length])

  const onFullscreenChange = useCallback((elementId) => {
    if ((videoRoom.livestream_player_type == "amazon_ivs" && videoRoom.play_mode == "live") || (videoRoom.vod_player_type == "amazon_ivs" && videoRoom.play_mode == "vod")) {
      let player = document.getElementById(elementId)
      if (player) {
        let overlay = videoOverlayContainerRef.current
        if (player != undefined && !player.contains(overlay)) {
          player.appendChild(overlay)
        }
      }
    }
  }, [videoRoom, videoOverlayContainerRef])

  return <>
    <VideoPlayer
      renderCustomContent={node.attribs["data-render-custom-player-elements"] != "false"}
      videoRoom={videoRoom}
      onFullscreenChange={onFullscreenChange}
      ontimeupdate={handleOnTimeUpdated}
    />

    {overlayNodes.length > 0 && <div
      ref={videoOverlayContainerRef}
      className={"video-overlay-container"}>
      {overlayNodes.map(node => <RenderedTimedVideoRoomContent
        videoRoom={videoRoom}
        currentTime={currentTime}
        node={node}
        options={options}
      />)}
    </div>}

    {timedContent.map(node => <RenderedTimedVideoRoomContent
      videoRoom={videoRoom}
      currentTime={currentTime}
      node={node}
      options={options}
    />)}
  </>
}

export default RenderedVideoRoom